import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "search-area" }
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = { class: "p1" }

import { computed, reactive } from 'vue';
import type { Device } from 'src/models/device';
import type { Lov } from 'src/models/master';
import type { AdminListTableField } from 'src/models/adminListTable';
import { lineBreakToBR } from 'src/lib/utils';
import { dtFormat } from 'src/lib/dateHelper';

type DisplayData = Device & {
  gName: string;
  carKindDisp: string;
  bikou1Disp: string;
  stoppedUseOnDisp: string;
};

interface SearchParams {
  deviceId: string;
  carName: string;
  carKind: string;
  usedStatus: string;
}

interface DeviceTableState {
  search: SearchParams;
  // 検索ボタン押下時に確定する検索条件。フィルタはこちらのみを参照する（入力中は自動検索しない）
  applied: SearchParams;
  showDestroyModal: boolean;
  destroyingDevice: Device | null;
}

const destroyModalTitle = '削除';
const destroyModalMsg = 'を削除してもよろしいですか？';

export default /*@__PURE__*/_defineComponent({
  __name: 'DeviceTable',
  props: {
    devices: {},
    carKinds: {}
  },
  emits: ["edit", "destroy", "search"],
  setup(__props: any, { emit: __emit }) {

const initSearchParams = (): SearchParams => ({
  deviceId: '',
  carName: '',
  carKind: '',
  usedStatus: '',
});

const props = __props;

const emit = __emit;

const state = reactive<DeviceTableState>({
  search: initSearchParams(),
  applied: initSearchParams(),
  showDestroyModal: false,
  destroyingDevice: null,
});

const doSearch = (): void => {
  emit('search');
  state.applied = { ...state.search };
};

const carKindMap = computed<Map<string, Lov>>(() => {
  return new Map(props.carKinds.map(e => [e.key, e]));
});

const filteredDevices = computed<Device[]>(() => {
  const qDeviceId = state.applied.deviceId;
  const qCarName = state.applied.carName;
  const qCarKind = state.applied.carKind;
  const qUsedStatus = parseInt(state.applied.usedStatus);
  return props.devices.filter(e => {
    if (qDeviceId && e.deviceId.indexOf(qDeviceId) === -1) return false;
    if (qCarName && e.carName.indexOf(qCarName) === -1) return false;
    if (qCarKind && e.carKind.indexOf(qCarKind) === -1) return false;
    if (!isNaN(qUsedStatus)) {
      // 利用中のみ抽出するので、停止されてたらはじく.
      if (qUsedStatus === 1 && e.stoppedUseOn) return false;
      // 利用停止中のみ抽出するので、停止してなかったらはじく.
      if (qUsedStatus === 0 && !e.stoppedUseOn) return false;
    }
    return true;
  });
});

const displayData = computed<DisplayData[]>(() => {
  return filteredDevices.value.map(device => {
    return {
      ...device,
      gName: lineBreakToBR(`${device.groupInfo.g2name}\n${device.groupInfo.g3name}`),
      carKindDisp: carKindMap.value.get(device.carKind)?.val ?? '',
      bikou1Disp: lineBreakToBR(device.bikou1),
      stoppedUseOnDisp: dtFormat(device.stoppedUseOn, 'yyyy/mm/dd'),
    };
  });
});

const edit = (obj: Device) => {
  emit('edit', obj);
};

const tryDestroy = (obj: Device) => {
  state.destroyingDevice = obj;
  state.showDestroyModal = true;
};

const doDestroy = () => {
  if (!state.destroyingDevice) return;

  emit('destroy', state.destroyingDevice);
  state.showDestroyModal = false;
};

const fields: AdminListTableField<DisplayData>[] = [
  { name: 'gName', label: '所属組織', type: 'html', class: 'ws-nowrap' },
  { name: 'deviceId', label: '車載器ID', class: 'ws-nowrap' },
  { name: 'carName', label: '車両番号' },
  { name: 'carKindDisp', label: '車種' },
  { name: 'stoppedUseOnDisp', label: '利用停止日' },
  { name: 'bikou1Disp', label: '備考', type: 'html' },
];

return (_ctx: any,_cache: any) => {
  const _component_AdminListTable = _resolveComponent("AdminListTable")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("form", {
        class: "search-form",
        onSubmit: _withModifiers(doSearch, ["prevent"])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _cache[5] || (_cache[5] = _createElementVNode("label", { class: "form-control-label device-id" }, "車載器ID", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.search.deviceId) = $event))
          }, null, 512), [
            [_vModelText, state.search.deviceId]
          ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _cache[6] || (_cache[6] = _createElementVNode("label", { class: "form-control-label car-name" }, "車両番号", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.search.carName) = $event))
          }, null, 512), [
            [_vModelText, state.search.carName]
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[8] || (_cache[8] = _createElementVNode("label", { class: "form-control-label car-kind" }, "車種", -1)),
          _withDirectives(_createElementVNode("select", {
            class: "form-control",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((state.search.carKind) = $event))
          }, [
            _cache[7] || (_cache[7] = _createElementVNode("option", { value: null }, null, -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.carKinds, (e) => {
              return (_openBlock(), _createElementBlock("option", {
                key: e.key,
                value: e.key
              }, _toDisplayString(e.val), 9, _hoisted_5))
            }), 128))
          ], 512), [
            [_vModelSelect, state.search.carKind]
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[10] || (_cache[10] = _createElementVNode("label", { class: "form-control-label use-no-use" }, "利用状況", -1)),
          _withDirectives(_createElementVNode("select", {
            class: "form-control",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((state.search.usedStatus) = $event))
          }, [...(_cache[9] || (_cache[9] = [
            _createElementVNode("option", { value: "" }, " 全て ", -1),
            _createElementVNode("option", { value: "1" }, " 利用中 ", -1),
            _createElementVNode("option", { value: "0" }, " 利用停止中 ", -1)
          ]))], 512), [
            [_vModelSelect, state.search.usedStatus]
          ])
        ]),
        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "form-group search-btn ta-center" }, [
          _createElementVNode("button", {
            type: "submit",
            class: "btn btn-primary"
          }, "検索")
        ], -1))
      ], 32)
    ]),
    _createVNode(_component_AdminListTable, {
      "display-data": displayData.value,
      fields: fields,
      onStartEdit: edit,
      onStartDestroy: tryDestroy
    }, null, 8, ["display-data"]),
    (state.showDestroyModal)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 0,
          title: destroyModalTitle,
          "show-bottom-dismiss-button": true,
          onClose: doDestroy,
          onDismiss: _cache[4] || (_cache[4] = ($event: any) => (state.showDestroyModal = false))
        }, {
          body: _withCtx(() => [
            _createElementVNode("div", null, [
              _createElementVNode("p", _hoisted_7, [
                _cache[12] || (_cache[12] = _createTextVNode("車載器ID", -1)),
                _cache[13] || (_cache[13] = _createElementVNode("span", { class: "colon" }, null, -1)),
                _createTextVNode(_toDisplayString(state.destroyingDevice?.deviceId), 1)
              ]),
              _createElementVNode("p", {
                class: "p2 font-mtx-desc",
                innerHTML: destroyModalMsg
              })
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})